module.exports = __webpack_public_path__ + "static/img/home_active.96b76a7b.svg";